import Navbar from "./Navbar";
import Footer from "./Footer";
import ThemeToggle from "../components/ThemeToggle";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex flex-col pb-20 lg:pb-0">
        {children}
      </main>
      <div className="fixed bottom-6 right-6 z-40">
        <ThemeToggle />
      </div>
      <Footer />
    </div>
  );
}
